import { generalFormBuilderPath } from "../../../../constants/formBuilder";

export const paths = {
  EVENT: "event",
  EVENT_AMBASSADOR_PROGRAM: "eventAmbassadorProgram",
  EVENT_AMBASSADOR_PROGRAM_ID: "eventAmbassadorProgramId",
  ORGANIZATION_ID: "organizationId",
  ORGANIZATION_CURRENCY_CONFIGURED: "organizationCurrencyConfigured",
  SELECTED_ORGANIZATION_CURRENCY: "selectedOrganizationCurrency",
  EFFECTIVE_MINIMUM_TARGET_INFO: "effective-minimum-target-info",
  APPLICATIONS_OPEN_DATE: "startsAt",
  VIP_PLACES_ALLOCATED: "availableSeats",
  DEFAULT_AMBASSADOR_STATUS: "defaultAmbassadorStatus",
  CUT_OFF_DATE_INFO: "cutOffDateInfo",
  FUNDRAISER_MINIMUM_TARGET_AMOUNT: "fundraiserMinimumTargetAmount",
  FUNDRAISING_DEADLINE_DATE: "fundraiseBy",
  NEW_VIP_PLACES_ALLOCATED: "newAvailableSeats",
  BANNER: "mainImagePath",
  INTRO_TEXT: "description",
  APPLICATION_ADDITIONAL: `${generalFormBuilderPath}.additional`,
  EDIT_PROGRAM_HEADER: "edit-program-header",
  EDIT_PROGRAM_SUBHEADER: "edit-program-subheader",
  EDIT_PROGRAM_APPLICATION_QUESTIONS_TAB: "edit-program-applicationQuestions",
  FUNDRAISING_GUARANTEE_TAB: "fundraisingGuarantee",
  FUNDRAISING_GUARANTEE_ENABLED: "donationPlan.enabled",
  FUNDRAISING_GUARANTEE_AGREEMENT_ENABLED: "donationPlan.template.value.agreement.enabled",
  FUNDRAISING_GUARANTEE_AGREEMENT_TITLE: "donationPlan.template.value.agreement.title",
  FUNDRAISING_GUARANTEE_AGREEMENT_CONTENT: "donationPlan.template.value.agreement.content",
  REGISTRATION_FEE_TAB: "registrationFee",
  REGISTRATION_FEE_ENABLED: "registrationFee.enabled",
  REGISTRATION_FEE_AMOUNT: "registrationFee.amount",
  REGISTRATION_FEE_NON_REFUNDABLE: "registrationFee.nonRefundable",
  REGISTRATION_FEE_TERMS: "registrationFee.terms",
};
